var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIDisease05Off(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6083 6H27.914C29.4333 6 30.6655 7.23221 30.6655 8.75157C30.6655 13.3124 26.9689 17.0091 22.408 17.0091H18.6055V6H18.6083Z",
    fill: "#B4B8BE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5883 17.0091L19.6312 13.1563C18.9594 11.8349 18.6081 10.3713 18.6081 8.88538V6H11.2734C5.78416 6 1.33203 10.4521 1.33203 15.9413V22.936C1.33203 24.9683 2.98242 26.6159 5.01473 26.6103C6.45881 26.6075 7.7663 25.76 8.3601 24.4414C8.73367 23.6106 9.50032 23.0279 10.4008 22.8913L13.4423 22.4314C16.8295 21.9184 19.8124 19.9335 21.591 17.0063L21.5883 17.0091Z",
    fill: "#C4C8CE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.56969 20.3855C7.33952 20.3855 7.96359 19.7614 7.96359 18.9916C7.96359 18.2217 7.33952 17.5977 6.56969 17.5977C5.79985 17.5977 5.17578 18.2217 5.17578 18.9916C5.17578 19.7614 5.79985 20.3855 6.56969 20.3855Z",
    fill: "#D2D6DC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.332 18.668C16.4366 18.668 17.332 17.7725 17.332 16.668C17.332 15.5634 16.4366 14.668 15.332 14.668C14.2275 14.668 13.332 15.5634 13.332 16.668C13.332 17.7725 14.2275 18.668 15.332 18.668Z",
    fill: "#D2D6DC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33073 14.6654C10.8035 14.6654 11.9974 13.4715 11.9974 11.9987C11.9974 10.5259 10.8035 9.33203 9.33073 9.33203C7.85797 9.33203 6.66406 10.5259 6.66406 11.9987C6.66406 13.4715 7.85797 14.6654 9.33073 14.6654Z",
    fill: "#B4B8BE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIDisease05Off);
export default __webpack_public_path__ + "static/media/i_disease_05_off.01fceed83879359caf0a19fad8d74da6.svg";
export { ForwardRef as ReactComponent };